import * as larvitar from "larvitar/dist/larvitar";

const csTools = larvitar.cornerstoneTools;
const getNewContext = csTools.importInternal("drawing/getNewContext");
const draw = csTools.importInternal("drawing/draw");
const setShadow = csTools.importInternal("drawing/setShadow");
const drawEllipse = csTools.importInternal("drawing/drawEllipse");
const drawHandles = csTools.importInternal("drawing/drawHandles");

class EllipticalRoiNoTextTool extends csTools.EllipticalRoiTool {
  constructor(props = {}) {
    super(props);
    this.name = "EllipticalRoiNoText";
  }

  renderToolData(evt) {
    const toolData = csTools.getToolState(evt.currentTarget, this.name);
    if (!toolData) return;

    const eventData = evt.detail;
    const { element } = eventData;
    const {
      handleRadius,
      drawHandlesOnHover,
      hideHandlesIfMoving,
      renderDashed
    } = this.configuration;
    const lineDash = csTools.getModule("globalConfiguration").configuration
      .lineDash;
    const context = getNewContext(eventData.canvasContext.canvas);

    draw(context, context => {
      for (let i = 0; i < toolData.data.length; i++) {
        const data = toolData.data[i];
        if (data.visible === false || !data.handles) continue;

        const color = csTools.toolColors.getColorIfActive(data);
        const handleOptions = {
          color,
          handleRadius,
          drawHandlesIfActive: drawHandlesOnHover,
          hideHandlesIfMoving
        };
        setShadow(context, this.configuration);

        const ellipseOptions = { color };
        if (renderDashed) ellipseOptions.lineDash = lineDash;

        drawEllipse(
          context,
          element,
          data.handles.start,
          data.handles.end,
          ellipseOptions,
          "pixel",
          data.handles.initialRotation
        );
        drawHandles(context, eventData, data.handles, handleOptions);
      }
    });
  }
}

export default EllipticalRoiNoTextTool;
